module.exports = __webpack_public_path__ + "img/Wp_2075.283d1908.png";